export const STATIC_RESOURCE_LOAD_ERROR_EVENT = 'static-resource-load-error';

const STATIC_RESOURCE_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /failed to load module script/i,
  /loading chunk .* failed/i,
  /chunkloaderror/i
];

function getErrorMessage(error) {
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (error && typeof error.message === 'string') return error.message;
  return String(error || '');
}

export function isStaticResourceLoadError(error) {
  const message = getErrorMessage(error);
  return STATIC_RESOURCE_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

export function notifyStaticResourceLoadError(error) {
  window.dispatchEvent(new CustomEvent(STATIC_RESOURCE_LOAD_ERROR_EVENT, { detail: error }));
}
